import {GlobalConstants} from "../data/GlobalConstants";
import {handleResponse} from "../util/functions";
import {getToken} from "../helpers/helperJWT";
import {loaderService} from "./loaderService";

const url = GlobalConstants.urlApi;

export const productosService = {
    getAllProducts,
    getProductoById,
    setStateProductoById,
    crudProductos,
    validarJerarquia,
    subirProductos,
    getAllJerarquias,
    crudJerarquias,
};


function getAllProducts() {
  loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({})
    };

    return fetch(`${url}/productos/getAllProducts`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getProductoById(codigo) {
  loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({codigo})
    };

    return fetch(`${url}/productos/getProductById`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function crudProductos(data) {
  loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({data})
    };

    return fetch(`${url}/productos/crudProductos`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function setStateProductoById(data) {
  loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/productos/setStateProductoById`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function validarJerarquia(data) {
  loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/productos/validarJerarquia`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function subirProductos(data) {
  loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/productos/subirProductos`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function getAllJerarquias() {
  loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify({})
    };

    return fetch(`${url}/productos/getAllJerarquias`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

function crudJerarquias(data) {
  loaderService.showLoader({label: "Cargando..."});

    const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/productos/crudJerarquias`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}



